var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bf54a891b309a6b3831afdc2d957c869.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    